<template>
  <div>
    <ul class="annexContainer">
      <li v-for="(item,index) in fileList" :key="index" class="fileItem">
        <img
          class="fileFlag"
          v-if="item.fileFormat == 'pdf'"
          src="./../../../../../assets/images/annex/pdf.png"
        >
        <img
          class="fileFlag"
          v-if="item.fileFormat == 'doc'"
          src="./../../../../../assets/images/annex/doc.png"
        >
        <img
          class="fileFlag"
          v-if="item.fileFormat == 'docx'"
          src="./../../../../../assets/images/annex/docx.png"
        >
        <img
          class="fileFlag"
          v-if="item.fileFormat == 'jpeg'"
          src="./../../../../../assets/images/annex/jpeg.png"
        >
        <img
          class="fileFlag"
          v-if="item.fileFormat == 'png'"
          src="./../../../../../assets/images/annex/png.png"
        >
        <img
          class="fileFlag"
          v-if="item.fileFormat == 'wps'"
          src="./../../../../../assets/images/annex/wps.png"
        >
        <img
          class="fileFlag"
          v-if="item.fileFormat == 'xls'"
          src="./../../../../../assets/images/annex/xls.png"
        >
        <img
          class="fileFlag"
          v-if="item.fileFormat == 'xlsx'"
          src="./../../../../../assets/images/annex/xlsx.png"
        >
        <span class="fileName ellipsis">
          {{
          item.fileName }}
        </span>
        <span class="fileSize">{{'(' +item.fileSizeKB +')'}}</span>
        <div class="closeFlag" v-if="showType=='upload'" @click="deleteItem(item,index)">
          <img class="normalFlag" src="./../../../../../assets/images/annex/delete_icon_nor.png">
          <img
            class="hoveFlag"
            src="./../../../../../assets/images/annex/delete_icon_hov_pre.png.png"
          >
        </div>
        <div class="closeFlag downloadBtn" v-if="showType=='download'" @click="downLoad(item)">
          <img
            class="normalFlag"
            style="float:right"
            src="./../../../../../assets/images/annex/down_icon_nor.png"
          >
          <img
            class="hoveFlag"
            style="float:right"
            src="./../../../../../assets/images/annex/down_icon_pre.png"
          >
        </div>
      </li>
      <li v-if="showType=='upload'&&fileList.length<5" class="fileItem uploadBtn">
        <upload
          class="uploadCom"
          :url="'/file/uploadContract'"
          @uploadSuccess="addFileList"
          @loadingEnd="isLoading = false"
          @loadingStart="isLoading = true"
          v-loading="isLoading"
          :fileList="fileList"
          @changCurrentIndex="changeFileListFlag"
        >
          <div slot="uploadContent" class="addDscp">
            <img class="addFlag" src="./../../../../../assets/images/annex/add_icon.png">添加附属文件
          </div>
        </upload>
      </li>
    </ul>
    <Dialog
      :visible="deleteDialogShow"
      :dialogTitle="'提示'"
      :width="'400px'"
      @closeDialog="closeDialog('deleteDialogShow')"
    >
      <div class="signDialog" slot="dialog">
        <div class="authDscp">
          <p>此操作将删除附件信息，是否继续？</p>
        </div>
        <div class="authHandlerBox">
          <div class="button buttonActive cursorPointer" @click="closeDialog('deleteDialogShow')">取消</div>
          <div class="button cursorPointer" @click="deleteContractConfrim">确定</div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import upload from "@common/uploadAnnex.vue";
import Dialog from "@common/Dialog.vue";
import BaseApi from "@lib/baseApi.js";
import download from "@lib/download.js";
let mimeMap = {
  doc: "application/msword",
  docx:
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
};
export default {
  props: {
    showType: {
      type: String,
      default: "download"
    },
    fileList: {
      type: Object,
      default: () => {
        return [];
      }
    },
    contractId: {
      type: String
    },
    contractName: {
      type: String
    }
  },
  data() {
    return {
      //当前正在操作的文件信息
      currentItem: null,
      // 当前正在操作的文件的索引
      currentIndex: "",
      deleteDialogShow: false,
      isLoading: false
    };
  },
  components: {
    upload,
    Dialog
  },
  mounted() {},
  methods: {
    addFileList(res) {
      res.datas.fileInfo.currentIndex = 1;
      this.fileList.push(res.datas.fileInfo);
    },
    deleteContractConfrim() {
      BaseApi.createRpcToken(
        "/file/delete",
        { id: this.currentItem.id },
        "post"
      ).then(
        data => {
          this.fileList.splice(this.currentIndex, 1);
          this.deleteDialogShow = false;
          this.$message.success("删除成功");
        },
        () => {}
      );
    },
    deleteItem(item, index) {
      this.currentItem = item;
      this.currentIndex = index;
      this.deleteDialogShow = true;
    },
    changeFileListFlag(current) {
      this.fileList[current.index].currentIndex = current.value;
    },
    downLoad(fileItem = {}) {
      BaseApi.createRpcToken(
        "/file/downloadContract",
        { id: this.contractId, fileId: fileItem.id },
        "get",
        true,
        false,
        true,
        "blob"
      )
        .then(
          res => {
            this.handlerDownload(res, fileItem);
          },
          () => {}
        )
        .catch(function(e) {
          console.log(e);
        });
    },
    downloadAll() {
      BaseApi.createRpcToken(
        "/file/downloadAttachmentZip",
        { id: this.contractId },
        "get",
        true,
        false,
        true,
        "blob"
      )
        .then(
          res => {
            this.handlerDownload(res);
          },
          () => {}
        )
        .catch(function(e) {
          console.log(e);
        });
    },
    handlerDownload(res, fileItem = {}) {
      download(
        new Blob([res.data], {
          type: mimeMap[fileItem.fileFormat] || res.headers["content-type"]
        }),
        fileItem.fileName
          ? fileItem.fileName + "." + fileItem.fileFormat
          : `${this.contractName}(附件).zip`,
        mimeMap[fileItem.fileFormat] || res.headers["content-type"]
      );
    },
    closeDialog(flag) {
      this[flag] = false;
    },
    save() {
      let annexIds = [];
      this.fileList.map(item => {
        annexIds.push(item.id);
      });
      return annexIds;
    }
  }
};
</script>
<style lang="scss" scope>
.annexContainer {
  .fileItem {
    width: 320px;
    height: 34px;
    float: left;
    margin-bottom: 17px;
    background: #f8f8f8;
    margin-right: 22px;
    line-height: 34px;
    position: relative;
    & > img {
      margin-left: 5px;
    }
    .el-loading-spinner {
      margin-top: -9px;
      .circular {
        height: 22px;
        width: 22px;
      }
    }
    .uploadCom {
      width: 100%;
      height: 100%;
      .addDscp {
        width: 320px;
        font-size: 12px;
        color: #e88078;
        line-height: 35px;
      }
      .addFlag {
        margin-right: 5px;
      }
    }
  }
  img {
    vertical-align: middle;
  }
  .fileName {
    padding-left: 7px;
    padding-right: 5px;
    font-size: 12px;
    color: #787878;
    display: inline-block;
    max-width: 155px;
    vertical-align: middle;
  }
  .uploadBtn {
    height: 32px;
    border: 1px dashed #dcdcdc;
    cursor: pointer;
    &:hover {
      border: 1px dashed #db4437;
    }
  }
  .fileSize {
    font-size: 12px;
    color: #b4b4b4;
    text-align: center;
    display: inline-block;
    vertical-align: middle;
  }

  .closeFlag {
    position: absolute;
    cursor: pointer;
    right: 5px;
    top: 0px;
    .normalFlag {
      display: inline-block;
    }
    .hoveFlag {
      display: none;
    }
    &:hover {
      .normalFlag {
        display: none;
      }
      .hoveFlag {
        display: inline-block;
      }
    }
  }
  .downloadBtn {
    right: 0px;
  }
}
</style>
